/// <reference lib="dom" />
/** @jsx h */
import { h } from "preact";
import { useEffect } from "preact/hooks";
import * as d3 from "d3";
import { QuantizedSine } from "@wbaudio/utils";
import { CreateChart } from "../../core/chart.ts";
import { InlineSize, ModeTheme, PadMargin } from "../../core/mode.ts";
import { useChart } from "../../core/useChart.ts";
import { LinesLayer } from "../../layers/lines.ts";

export const BitcrusherInlineSize = { ...InlineSize, pad: 2 };

function CreateBitcrusherChart(container: HTMLElement) {
  const steps = LinesLayer();
  const chart = CreateChart(container, {
    height: BitcrusherInlineSize.height,
    margin: PadMargin(BitcrusherInlineSize.pad),
    x: d3.scaleLinear().domain([0, 1]),
    y: d3.scaleLinear().domain([-1, 1]),
    theme: ModeTheme("inline"),
    layers: [steps],
  });
  return { chart, steps, destroy: chart.destroy };
}

export interface BitcrusherGraphProps {
  bits: number;
  normfreq: number;
}

export function BitcrusherGraph(props: BitcrusherGraphProps) {
  const { ref, chart } = useChart(CreateBitcrusherChart, []);
  useEffect(() => {
    if (!chart) return;
    const points = QuantizedSine(props.bits, props.normfreq);
    chart.steps.set([{ id: "steps", points, step: true }]);
    chart.chart.setDomain([0, points.length - 1]);
  }, [chart, props.bits, props.normfreq]);
  return <div ref={ref} />;
}
